export default {
    ticketsAbiertos: []
}